import styled from 'styled-components';
import themeData from 'utils/theme/themeData';

const { typography } = themeData;

export const VendorsHeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 0 24px 15px 24px;
  box-shadow: 0px 1px 0px ${({ theme }) => theme.colors.grey000};
`;

export const VendorsHeaderFilterWrapper = styled.div`
  display: flex;
  flex-grow: 1;
`;

export const VendorsHeaderFilterItemWrapper = styled.div`
  padding: 17px 16px;
  cursor: pointer;

  ${({ selected, theme }) =>
    selected &&
    `
    color: ${theme.colors.blueMain};
    box-shadow: inset 0 -4px 0 ${theme.colors.blueMain};
  `}
`;

export const VendorsHeaderFilterItem = styled(typography.BodyTextOneRegularTypography)`
  margin: 0;
`;

export const VendorsHeaderCreateVendorButton = styled(typography.BodyTextOneRegularTypography)`
  padding: 8px 42px;
  height: fit-content;
  color: ${({ theme }) => theme.colors.grey600};
  background-color: ${({ theme }) => theme.colors.grey100};
  cursor: pointer;
  padding: 8px 16px;
  border: 1px solid ${({ theme }) => theme.colors.grey300};
  border-radius: 4px;
  &:before {
    content: '\\e910';
    font-family: 'Icomoon';
    font-size: 12px;
    margin-inline-end: 8px;
  }
`;
